import { TemplatePageProps } from './types'
import { TileBlitzEntity } from './entity'
import Icon from 'images/games/tile-blitz/icon.png'
import Detail1 from 'images/games/tile-blitz/detail1.png'
import {
  BingoClashLink,
  DominoesLink,
  DunkShotLink,
  MatchNFlipLink,
  NumbersBlitzLink,
  PlaySolitaireOnlineLink,
  Pocket7GamesLink,
  PoolClashLink,
  TwentyOneGoldLink,
} from '../../components'
import { Pocket7GamesSwiper } from './pocket7games'

export const TileBlitzDetail: TemplatePageProps = {
  entity: {
    ...TileBlitzEntity,
    logo: Icon,
    title: <>Tile Blitz: A Colorful Tetris Online Experience</>,
    description: (
      <>
        Tile Blitz, a fun <strong>block puzzle game</strong> under the Pocket7Games app, takes{' '}
        <strong>classic Tetris</strong> to new heights with vibrant graphics and exciting gameplay. Use strategy to
        clear lines, score big, and have the opportunity to win real money. Download the Pocket7Games App now! Available
        on the Apple Store, Galaxy Store, and as an Android APK!
      </>
    ),
  },
  swiper: Pocket7GamesSwiper,
  content: [
    {
      title: <>How to Play Tile Blitz</>,
      description: (
        <>
          In Tile Blitz, your goal is to strategically place tiles to complete and clear rows and columns, maximizing
          your score. You only receive three tiles at a time, so careful placement is key. Aim to clear multiple lines
          at once for higher points. Speed matters—make quick decisions and anticipate tile placements to clear rows
          efficiently. Setting up combos and chain reactions will earn you extra points and give you a competitive edge.
          The more you practice, the faster and more strategic you&#39;ll become. Stay focused and enjoy quick
          puzzle-solving in this vibrant <strong>Tetris online</strong> game!
        </>
      ),
      image: Detail1,
    },
    {
      title: <>Explore More Casual Games to Win More!</>,
      description: (
        <>
          Tile Blitz offers a colorful and engaging <strong>block puzzle</strong> experience, where quick thinking and
          smart moves are key to scoring big! With smooth gameplay and opportunities to earn cash, every round brings
          satisfaction. Want to explore more fun games? Dive into the{' '}
          <Pocket7GamesLink>Pocket7Games app</Pocket7GamesLink> and enjoy titles like <PlaySolitaireOnlineLink />,{' '}
          <BingoClashLink />, <MatchNFlipLink />, <TwentyOneGoldLink />, <NumbersBlitzLink />, <PoolClashLink />,{' '}
          <DunkShotLink />, and <DominoesLink />. Whichever you choose, fun is guaranteed when you start playing today!
        </>
      ),
    },
  ],
} as TemplatePageProps
